module.exports = __webpack_public_path__ + "static/media/PeanutButter.448a949c.pdf";